const MOMReducer = (state = {}, action) => {
    switch (action.type) {
      case "MOM_LISTVIEW":
        return Object.assign({}, state, {
          MOM_ListView: action.data
        });
      case "MASTERDATA_MATERIAL":
        return Object.assign({}, state, {
          MASTERDATA_MATERIAL: action.data
        });
      case "MOM_ADD":
        return Object.assign({}, state, {
          MOM_Add: action.data
        });
      case "MOMEDIT_DOCS":
        return Object.assign({}, state, {
          geteditmom: action.data
        });
  
      case "SHARE_MOMDATAS":
        return Object.assign({}, state, {
          sharedmomdata: action.data
        });
        
      case "ERROR_MOMDATAS":
        return Object.assign({}, state, {
          errormompass: action.data
        });
      default:
        return state;
    }
  };
  
  export default MOMReducer;
  
  